import { InternalAxiosRequestConfig } from "axios";
import { UseAuthStore } from "@/features/auth/useAuthStore";

export function authRequestInterceptor(config: InternalAxiosRequestConfig, auth: UseAuthStore) {
  const runtimeConfig = useRuntimeConfig();

  // In integration tests (DISABLE_LOGIN=true), no token is expected — skip auth entirely
  if (runtimeConfig.public.DISABLE_LOGIN) {
    return config;
  }

  if (!auth.bearerToken) {
    console.warn("[auth-interceptor] No valid token available, triggering logout");
    auth.logoutOnce();
    throw new Error("No valid auth token available");
  }

  if (config.headers) {
    config.headers.Authorization = `Bearer ${auth.bearerToken}`;
  }
  return config;
}
